import { ISelectAddressMachineContext } from './types';

export const isUserReady = (context: ISelectAddressMachineContext) =>
  context.isUserReady;

export const isAddressPrefilled = (context: ISelectAddressMachineContext) => {
  const { addresses, shippingAddressSelected, addressPrefilled } = context;
  let areAddressesIdentical = false;

  // Compare default address and last order address based on street and postcode
  // This prevent to open a prefilled form address at each checkout entry
  if (addresses.length > 0 && addressPrefilled) {
    const identicalAddress = addresses.find(
      (address) =>
        addressPrefilled.street === address.street &&
        addressPrefilled.postalCode === address.postcode &&
        addressPrefilled.city === address.city &&
        addressPrefilled.country === address.countryCode,
    );

    areAddressesIdentical = identicalAddress != null;
  }

  return Boolean(
    !shippingAddressSelected && addressPrefilled && !areAddressesIdentical,
  );
};

export const isAddressesEmpty = (context: ISelectAddressMachineContext) =>
  context.addresses.length === 0;

export const isAddressSelected = (context: ISelectAddressMachineContext) =>
  Boolean(context.shippingAddressSelected);

export const isAddressNotSelected = (context: ISelectAddressMachineContext) =>
  !context.shippingAddressSelected;

export const isBillingEqualShippingChecked = (
  context: ISelectAddressMachineContext,
) => context.isBillingAndShippingEqual;

export const isCreatingForBillingAddress = (
  context: ISelectAddressMachineContext,
) => context.creatingForBillingOnly;

export const isUpdatingOnlyBillingAddress = (
  context: ISelectAddressMachineContext,
  event,
) =>
  context.creatingForBillingOnly &&
  event.data.data.updateAddress.id !== context.shippingAddressSelected?.id;
